import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackMappingModel } from 'common/models/page-models/Feedback-Mapping/feedback-mapping-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackMappingFormWidgetService } from 'common/widget/feedback-mapping/feedback-mapping-form-widget.service';


@Injectable({
    providedIn: 'root'
})
export class  FeedbackMappingFormResolver extends FormResolverService< FeedbackMappingModel> {
    constructor(
        protected fs:  FeedbackMappingFormWidgetService,
        protected override  router: Router,
        protected override  systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

}
